// import {Howl} from "howler";
import { Constants, Interfaces } from "@ambifi/ambifi-synthetic-voice";
import { playNarrationAudioElement } from "../../actions/playerActions";
// Howler.autoUnlock = false;
// const Sound = {};

const { SyntheticVoiceAudioProvider } = Interfaces;
const { EVENT_TYPE_SPEECH_START, EVENT_TYPE_SPEECH_FINISH } = Constants;

let AUDIO_RATE = 1.0;

const PROVIDER_VOICE_SPEEDS = {
	[Constants.VOICE_SPEED_SLOWEST]: 0.65,
	[Constants.VOICE_SPEED_SLOWER]: 0.75,
	[Constants.VOICE_SPEED_SLOW]: 0.85,
	[Constants.VOICE_SPEED_NORMAL]: 1.0,
	[Constants.VOICE_SPEED_FAST]: 1.3,
	[Constants.VOICE_SPEED_FASTER]: 1.6,
	[Constants.VOICE_SPEED_FASTEST]: 1.9
};

function getNarrationAudioElement() {
	return document.getElementById("narration_audio");
}


class AudioProvider extends SyntheticVoiceAudioProvider {
	constructor() {
		super();
		// this.currentSound = null;
		this.audioElement = getNarrationAudioElement();
		this.paused = false;
	}

	_onAudioStart() {
		// console.log("START EVENT (Tts) speech request", this);
		this.fireEvent(EVENT_TYPE_SPEECH_START);
	}
	_onAudioEnd() {
		// console.log("FINISH EVENT (Tts) speech request", this);
		if (this.audioElement) {
			delete this.audioElement.src;
		}
		this.fireEvent(EVENT_TYPE_SPEECH_FINISH);
	}

	start(speechRequest) {
		const { url } = speechRequest;
		return this.play(url);
	}

	play(url) {
		console.log("Play URI", url);
		const self = this;
		this._onAudioStart();
		return new Promise(async (resolve, reject) => { // eslint-disable-line no-async-promise-executor
			try {
				if (this.audioElement && !this.audioElement.paused) {
					self.stop(async () => {
						await self.playOnly(url);
					});
				} else {
					await self.playOnly(url);
				}
				self._onAudioEnd();
				resolve();
			} catch (e) {
				console.error("Audio: An error occurred while attempting to play audio", e);
				reject(e);
			}

		});

	}

	playOnly(url) {
		// const self = this;
		return new Promise((resolve, reject) => {
			console.log("Play URI", url);
			if (!url) {
				reject("A URL is required in order to play a sound.");
			}

			let src = url;
			if (url && url.hasOwnProperty("uri")) {
				src = url.uri;
			}

			if (url === "init") {
				url = "https://assets-ambifi-com.s3.amazonaws.com/public/audio/silence.mp3";
				src = url;
			}
			console.log("Audio: About to play ", url);
			// if (_uri.startsWith("file://")) {
			// 	_uri = require(_uri);
			// }

			const errorFn = (e) => {
				const message = url === "init" ? "initialized audio" : "playback failed due to audio decoding errors";
				console.warn("Audio: An error occurred while attempting to play audio", message, e);
				reject(message);
			};


			this.audioElement = getNarrationAudioElement();
			this.audioElement.src = src;

			// this.audioElement.onabort = errorFn;
			this.audioElement.onerror = errorFn;
			this.audioElement.onended = () => {
				console.log("Audio: successfully finished playing");
				resolve();
			};

			// self.currentSound = new Howl({
			// 	src,
			// 	html5: true,
			// 	preload: true,
			// 	onend: () => {
			// 		// console.log("successfully finished playing");
			// 		resolve();
			// 	},
			// 	onloaderror: errorFn,
			// 	onplayerror: () => {
			// 		self.currentSound.once("unlock", () => {
			// 			self.currentSound.play();
			// 		});
			// 	}
			// });
			this.audioElement.playbackRate = AUDIO_RATE;

			try {
				// const self = this;
				let hasStartedPlaying = false;
				this.audioElement.oncanplay = () => {
					/**
					 * Once again a Mobile Safari work around ...
					 * https://github.com/twilio/twilio-video.js/issues/941
					 * https://github.com/twilio/twilio-video.js/issues/922
					 * Sometimes Mobile Safari < 13.5 doesn't play remote audio, no specific reason why (see links above)
					 * the issue is that it gets into oncanplay but never actually plays the audio (onplaying never called)
					 * The work around is to detect this issue, it is usually oncanplay directly followed by onplaying (almost 0 time inbetween)
					 * So we set a timeout to help recover when an issue occurs.
					 */
					console.log("Audio: Audio Element oncanplay!", url);
					setTimeout(() => { 
						if (!hasStartedPlaying) {
							this.audioElement.play();
						}
					}, 500);
				};
				this.audioElement.onstalled = () => {
					console.log("Audio: Audio Element onstalled!", url);
				};
				this.audioElement.onsuspend = () => {
					console.log("Audio: Audio Element onsuspend!", url);
				};
				this.audioElement.onwaiting = () => {
					console.log("Audio: Audio Element onwaiting!", url);
				};
				// let purpusePause = false;
				this.audioElement.onpause = () => {
					// if (purpusePause) {
					// 	this.audioElement.play();
					// }
					// purpusePause = false;
					// c++;
					console.log("Audio: Audio Element onpause!", url);
				};
				this.audioElement.oncomplete = () => {
					console.log("Audio: Audio Element oncomplete!", url);
				};
				this.audioElement.onloadedmetadata = () => {
					console.log("Audio: Audio Element onloadedmetadata!", url);
				};
				this.audioElement.onplay = () => {
					console.log("Audio: Audio Element onplay!", url);
				};
				this.audioElement.onplaying = () => {
					hasStartedPlaying = true;
					console.log("Audio: Audio Element onplaying!", url);
				};
				console.log("Audio: About to play audio!", url);
				// purpusePause = true;
				this.audioElement.pause();

				playNarrationAudioElement();


				// once(this.audioElement, "play").then(() => {
				// 	const onPause = once(this.audioElement, "pause");
				// 	this.audioElement.pause();
				// 	return onPause;
				// }).then(() => {
				// 	return this.audioElement.play();
				// }).then(() => {
				// 	console.log("Pause/play called!");
				// });
				console.log("Audio: Playing audio!", url);
			} catch (e) {
				console.warn("Audio: Failed to play audio", e);
			}

			// self.currentSound = new Howl(src, "", (error) => {
			// 	// console.log("Instantiated new Sound", src, error);
			// 	if (error) {
			// 		console.warn("failed to load the sound", error);
			// 		reject(error);
			// 		return;
			// 	}
			// 	// loaded successfully
			// 	// console.log("duration in seconds: " + self.currentSound.getDuration() + "number of channels: " + self.currentSound.getNumberOfChannels());

			// 	// Play the sound with an onEnd callback
			// 	self.currentSound.play((success) => {
			// 		if (success) {
			// 			// console.log("successfully finished playing");
			// 			resolve();
			// 		} else {
			// 			const message = "playback failed due to audio decoding errors";
			// 			console.warn(message);
			// 			reject(message);
			// 		}
			// 	});


			// });
		});
	}

	togglePauseResume() {
		if (this.paused) {
			this.resume();
		} else {
			this.pause();
		}
	}

	isPlaying() {
		return !this.audioElement || !this.audioElement.paused;
	}

	pause() {
		if (this.isPlaying()) {
			this.paused = true;
			if (this.audioElement) {
				this.audioElement.pause();
			}
		}
	}

	resume() {
		if (this.paused) {
			this.paused = false;
			if (this.audioElement && this.audioElement.paused) {
				this.audioElement.play();
			}
		}
	}

	stop() {
		this.paused = false;
		if (this.audioElement) {
			this.audioElement.pause();
			this.audioElement.currentTime = 0;
			this._onAudioEnd();
		}
	}

	static setDefaultSpeed(speed) {
		const speedConstant = SyntheticVoiceAudioProvider.getSpeedConstantFromValue(speed);
		console.log("Setting audio speech rate", speed);
		AUDIO_RATE = PROVIDER_VOICE_SPEEDS[speedConstant];
	}
}

export default AudioProvider;